module.exports = __webpack_public_path__ + "static/media/64.6963a2d7.png";